import { useTranslation } from 'react-i18next';
import { Button } from '@frekuent/orbit/components';
import { i18nKeys } from '@/shared/i18n';
import FrekuentLogo from '@/shared/ui/icons/FrekuentLogo';
import { clearAllStoresAndLocalStorage } from '@/legacy/utils';

type Props = {
	onReset?: () => void;
};

const ErrorPage = ({ onReset }: Props) => {
	const { t } = useTranslation();

	const handleReset = () => {
		if (onReset) {
			onReset();
		} else {
			window.location.reload();
		}
	};

	const handleLogout = () => {
		clearAllStoresAndLocalStorage();
		window.location.href = '/login';
	};

	return (
		<div className='min-h-screen flex items-center justify-center bg-fill-nude py-12 px-4'>
			<div className='max-w-sm w-full text-center space-y-6'>
				<FrekuentLogo
					className='mx-auto'
					width={48}
					height={48}
				/>
				<div className='space-y-2'>
					<h1 className='text-xl font-bold text-fill-primary'>{t(i18nKeys.common.error.title)}</h1>
					<p className='text-sm text-text-secondary'>{t(i18nKeys.common.error.description)}</p>
				</div>
				<div className='mx-auto w-full flex justify-center gap-3'>
					<Button
						onClick={handleReset}
						type='button'
						variant='highlighted'
					>
						{t(i18nKeys.common.error.refresh)}
					</Button>
					<Button
						onClick={handleLogout}
						type='button'
						variant='default'
					>
						{t(i18nKeys.common.error.logout)}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default ErrorPage;
